// extracted by mini-css-extract-plugin
export default {"tableActionsTitle":"app-portainer-components-datatables-components-ActionsMenuTitle-module__table-actions-title"};